const state = {
    attachments: {
		size: 25, // in MB,
		types: ['.jpg','.png','.pdf','.doc','.docx','.xls','.xlsx','.ppt','.pptx','.csv','.txt','.zip','.rar','.rtf']
	},
	images: {
		size: 5, // in MB
	},
	videos: {
		size: 150, // in MB
	},
	post: {
		content: 3000,
		breakAfter: 210
	},
	poll: {
		answers: 10
	}
};
const getters = {
    attachments: state => {
        return state.attachments;
    },
	images: state => {
		return state.images
	},
	videos: state => {
		return state.videos
	},
	post: state => {
		return state.post
	},
	poll: state => {
		return state.poll
	}
};

const mutations = {
    setAttachments(state, payload) {
        state.attachments = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
};